import { useEffect, useRef } from 'react'

const useUndoRedoShortcuts = ({ onUndo, onRedo }) => {
  const onUndoRef = useRef(onUndo)
  const onRedoRef = useRef(onRedo)

  useEffect(() => {
    onUndoRef.current = onUndo
    onRedoRef.current = onRedo
  })

  useEffect(() => {
    const handleKeyDown = event => {
      const isHistoryShortcut = (event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'z'

      if (!isHistoryShortcut) return

      event.preventDefault()

      if (event.shiftKey) {
        onRedoRef.current()
        return
      }

      onUndoRef.current()
    }

    document.addEventListener('keydown', handleKeyDown)

    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [])
}

export default useUndoRedoShortcuts
